import { PieChart } from '@components/chart/PieChart'
import { DeviceCategoryType } from '@models/dashboard/WriterOverViewType'

export function DeviceChart({ data }: { data: DeviceCategoryType[] }) {
  return (
    <div className='w-full'>
      <PieChart
        title='Device'
        data={data}
        legendStyle='bottom'
        style={{ height: `calc(270px + ${data.length * 40}px)`, width: '100%' }}
      />
    </div>
  )
}
